import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import ContextMenu from "../../components/contextMenu";
import {Button} from "primereact/button";
import HeaderScreenPresval from "../../components/headerScreenPresval";
import {RadioButton} from "primereact/radiobutton";
import NumberFormat from "react-number-format";
import {InputText} from "primereact/inputtext";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";
import PropTypes from 'prop-types';
import {Calendar} from "primereact/calendar";
import {CALENDAR_ES, DATE_FORMAT_CALENDAR} from "../../utils/constants/Constants";
import {Panel} from "primereact/panel";
import UploadFilePresval from "../../components/uploadFile/uploadFileSingle";


const AladdinReportView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle={"Reportes Aladdin"}
                                             onExpand={props.clearFilters}
                                             withButtons={false}
                                             isExpanded={props.isReport}
                        >
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <RadioButton inputId="inicioPrestamos" name="valueAladdinReport"
                                                 value={props.optionsFilter.inicioPrestamos}
                                                 onChange={props.onChangeFilters}
                                                 checked={props.filters.valueAladdinReport === props.optionsFilter.inicioPrestamos} />
                                    <label htmlFor="inicioPrestamos" className="p-radiobutton-label">Inicio de Préstamos</label>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <RadioButton inputId="garantiasES" name="valueAladdinReport"
                                                 value={props.optionsFilter.garantiasES}
                                                 onChange={props.onChangeFilters}
                                                 checked={props.filters.valueAladdinReport === props.optionsFilter.garantiasES} />
                                    <label htmlFor="garantiasES" className="p-radiobutton-label">Garantías de Entrada / Salida</label>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <RadioButton inputId="restricciones" name="valueAladdinReport"
                                                 value={props.optionsFilter.restricciones}
                                                 onChange={props.onChangeFilters}
                                                 checked={props.filters.valueAladdinReport === props.optionsFilter.restricciones} />
                                    <label htmlFor="restricciones" className="p-radiobutton-label">Restricciones</label>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="p-grid p-align-center p-justify-end">
                            <div className="p-col-12 p-md-12 p-lg-12" style={{textAlign: 'right'}}>
                                <ContextMenu menuOptions={props.exportOptions}
                                             isButton={true}
                                             label="Enviar correo"/>
                            </div>
                        </div>
                        <Panel header="Datos UDI"
                               style={{
                                   visibility:
                                       props.filters.valueAladdinReport !== "garantiasES" ?
                                           'hidden' : ''
                               }}
                        >
                            <div className="p-grid p-align-center p-justify-end">
                                <div className="p-col-12 p-md-1 p-lg-1">
                                    <SubtitleLabel header="Valor: " align={"right"}/>
                                </div>
                                <div className="p-col-12 p-md-5 p-lg-2">
                                    <NumberFormat name="udiValue"
                                                  decimalScale={6}
                                                  maxLength={8}
                                                  allowNegative={false}
                                                  customInput={InputText}
                                                  value={props.filters.udiValue}
                                                  onChange={props.onChangeFilters}
                                                  placeholder="Ex: 9.99"
                                    />
                                </div>
                                <div className="p-col-12 p-md-1 p-lg-1">
                                    <SubtitleLabel header="Fecha: " align={"right"}
                                    />
                                </div>
                                <div className="p-col-12 p-md-1 p-lg-2">
                                    <Calendar name="udiDate"
                                              locale={CALENDAR_ES}
                                              dateFormat={DATE_FORMAT_CALENDAR}
                                              disabledDays={[0, 6]}
                                              readOnlyInput={true}
                                              value={props.filters.udiDate}
                                              onChange={props.onChangeFilters}
                                              minDate={props.filters.today}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange={CALENDAR_ES['yearRange']}
                                    />
                                </div>
                                <div className="p-col-12 p-md-3 p-lg-2">
                                    <Button label="Guardar" onClick={props.saveUdiValue}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-lg-2">
                                    <UploadFilePresval type={["text/csv", "text/plain"]}
                                                       size="1000000"
                                                       urlAction="/appapv/saveUdiFromFile.action"
                                                       className="p-button-secondary"
                                                       titleHeader="Cargar archivo"
                                                       titleButton="Importar UDI"
                                                       errorTypeMessage="El documento debe ser csv."
                                                       errorSizeMessage="El archivo es muy pesado."
                                                       instructions="Debe ser un archivo de texto con comas de separación entre los datos."
                                                       />
                                </div>

                                    <div className="p-col-12 p-md-3 p-lg-2">
                                        <Button label="Exportar" className="p-button-secondary"
                                                onClick={props.exportUdiValues}
                                        />
                                    </div>
                                </div>
                        </Panel>

                    </Grid>
                    {props.confMsg}
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default AladdinReportView;

AladdinReportView.propTypes = {
    filters: PropTypes.element.isRequired,
    onChangeFilters: PropTypes.func.isRequired,
    saveUdiValue: PropTypes.func.isRequired,
    exportUdiValues: PropTypes.func.isRequired,
}